

























































































































































































import {
  computed,
  defineComponent,
  PropType,
  ref,
  toRefs
} from '~/utils/nuxt3-migration'
import { AuditAvailableProvider } from '~/models/audit/available'
import AuditsShopEntry from '~/components/shared/classified/audits/AuditsShopEntry.vue'
import { useI18n } from '~/compositions/i18n'
import CPrice from '~/components/shared/configurable/CPrice.vue'
import { useNamespacedStore } from '~/compositions/store'
import { CLASSIFIED_VIEW_NS } from '~/store/modules/shared/classifieds/view/state'
import AuthorizedPartnerBadge from '~/components/shared/audits/badges/AuthorizedPartnerBadge.vue'
import SpotCheckBadge from '~/components/shared/audits/badges/SpotCheckBadge.vue'
import { ciLocationPin } from '~/icons/source/regular/location-pin'
import { ciAngleUp } from '~/icons/source/regular/angle-up'
import { ciAngleDown } from '~/icons/source/regular/angle-down'
import { defineComponentTranslations } from '~/utils/i18n'
import { useUserAgent } from '~/compositions/user-agent'
import CImg from '~/components/shared/configurable/image/CImg.vue'
import CAccordion from '~/components/shared/configurable/accordion/CAccordion.vue'
import { ciMarketplace } from '~/icons/source/regular/marketplace'
import { ciStar } from '~/icons/source/solid/star'
import { AuditShop } from '~/models/audit/shop'
import { THREE_MONTHS } from '~/constants/duration'
import { useCookies } from '~/compositions/useCookies'
import CExpandableInfo from '~/components/shared/configurable/CExpandableInfo.vue'
import { useStatic } from '~/compositions/useStatic'
import { useAudits } from '~/compositions/audits'

export default defineComponent({
  components: {
    CExpandableInfo,
    AuditsShopEntry,
    CPrice,
    AuthorizedPartnerBadge,
    SpotCheckBadge,
    CImg,
    CAccordion
  },
  props: {
    availableProviders: {
      type: Array as PropType<AuditAvailableProvider[]>,
      required: true
    }
  },
  setup(props, { emit }) {
    const { availableProviders } = toRefs(props)
    const showMore = ref([])
    const { t } = useI18n()
    const { isMobile } = useUserAgent()
    const cookies = useCookies()
    const s = useStatic()
    const { placeholderIcon } = useAudits()

    const { getters } = useNamespacedStore(CLASSIFIED_VIEW_NS)
    const isClassifiedOwner = computed(() => getters('isOwn'))

    function handleShowMoreProviders(id: number) {
      if (showMore.value.includes(id)) {
        showMore.value = showMore.value.filter((pid: string) => pid !== id)
      } else {
        showMore.value.push(id)
      }
    }

    function calcDistance(shop: AuditShop) {
      if (!shop.distanceFromGeolocation) {
        return null
      }
      const distance: number = parseFloat(
        shop.distanceFromGeolocation.toFixed(0)
      )
      return `${distance} ${t('km_away')}`
    }

    const onShopContainerClick = (index: number) => {
      const provider = availableProviders.value[index]
      if (provider.shops.length === 1) {
        emitSelectShop(provider, provider.shops[0])
      }
    }

    const emitSelectShop = (
      provider: AuditAvailableProvider,
      shop: AuditShop
    ) => {
      emit('select-shop', {
        ...shop,
        auditProvider: provider
      })
    }

    const selfAuditPromoCookieExists = !!cookies.get('scamWarning')
    const setAuditPromoOfferCookie = () => {
      cookies.set('selfAuditPromoDismiss', 1, { maxAge: THREE_MONTHS })
    }

    const infoSteps = [
      {
        title: t('audits_expandable_info_step_1_title'),
        img: s('/nuxt-static/img/audits/info-step-1.png'),
        content: t('audits_expandable_info_step_1_description')
      },
      {
        title: t('audits_expandable_info_step_2_title'),
        img: s('/nuxt-static/img/audits/info-step-2.png'),
        content: t('audits_expandable_info_step_2_description')
      },
      {
        title: t('audits_expandable_info_step_3_title'),
        img: s('/nuxt-static/img/audits/info-step-3.png'),
        content: t('audits_expandable_info_step_3_description')
      }
    ]

    return {
      onShopContainerClick,
      handleShowMoreProviders,
      showMore,
      placeholderIcon,
      ciLocationPin,
      ciAngleUp,
      ciAngleDown,
      ciMarketplace,
      ciStar,
      setAuditPromoOfferCookie,
      isMobile,
      t,
      selfAuditPromoCookieExists,
      calcDistance,
      infoSteps,
      isClassifiedOwner,
      emitSelectShop
    }
  },
  i18n: defineComponentTranslations({
    spots: {
      en: '{count} spots',
      el: '{count} σημεία'
    },
    partner_stores: {
      en: '{count} partner audit shops',
      el: '{count} συνεργαζόμενα συνεργεία'
    },
    free_days_promotion_title: {
      en: 'Free 3 days promotion of your classified!',
      el: 'Δώρο 3 ημέρες προώθηση της αγγελίας σου!'
    },
    free_days_promotion_body: {
      en:
        "By purchasing a technical inspection for your vehicle, you receive a free 3-day promotion and increase your classified's traffic by up to 700%.",
      el:
        'Με την αγορά τεχνικού ελέγχου, λαμβάνεις δώρο 3 ημέρες προώθηση και αύξησε την επισκεψιμότητα της αγγελίας σου έως 700%.'
    },
    audits_expandable_info_title: {
      en: 'How can I buy an technical inspection?',
      el: 'Πώς αγοράζω τεχνικό έλεγχο;'
    },
    audits_expandable_info_step_1_title: {
      en: 'Choose a provider and a package for the technical inspection',
      el: 'Επιλέγεις πάροχο και πακέτο για τον τεχνικό έλεγχο'
    },
    audits_expandable_info_step_1_description: {
      en:
        'You choose the provider you want and choose the package that best meets your needs. Choose up to 350 inspection points for cars, motorcycles or commercial vehicles up to 7.5 tons from authorized Car.gr partners.',
      el:
        'Επιλέγεις τον πάροχο που θες και διαλέγεις το αντίστοιχο πακέτο που καλύπτει καλύτερα τις ανάγκες σου. Διάλεξε έλεγχο έως 350 σημείων για αυτοκίνητα, μηχανές ή επαγγελματικά έως 7,5 τόνων από εξουσιοδοτημένους συνεργάτες του Car.gr.'
    },
    audits_expandable_info_step_2_title: {
      en: 'The vehicle is inspected by the provider',
      el: 'Το όχημα ελέγχεται από τον πάροχο'
    },
    audits_expandable_info_step_2_description: {
      en:
        'Once the vehicle inspection is purchased with an authorized partner, the vehicle will be thoroughly examined. Many of them can also come to the location of the car, for even greater convenience.',
      el:
        'Αφού αγοράσεις τον τεχνικό έλεγχο από έναν από τους συνεργάτες μας, το όχημα ελέγχεται εξονυχιστικά. Πολλοί από αυτούς μπορούν να μεταβούν και στο σημείο που βρίσκεται το αυτοκίνητο, για ακόμα μεγαλύτερη ευκολία '
    },
    audits_expandable_info_step_2_description_2: {
      en: 'You’ll spot them by the {badge} badge when making a purchase',
      el: 'Θα τους βρεις με την ετικέτα {badge} κατά την αγορά.'
    },
    audits_expandable_info_step_3_title: {
      en: 'You receive the inspection certificate via email',
      el: 'Λαμβάνεις το πιστοποιητικό τεχνικού ελέγχου μέσω email'
    },
    audits_expandable_info_step_3_description: {
      en:
        'Once the inspection is complete, you will receive a written evaluation of the vehicle including all details of its condition.',
      el:
        'Με την ολοκλήρωση του ελέγχου θα λάβεις τη γραπτή αξιολόγηση του οχήματος η οποία θα περιλαμβάνει όλες τις λεπτομέρειες της κατάστασής του.'
    }
  })
})
